import { render, staticRenderFns } from "./knob.vue?vue&type=template&id=08c15de2&"
import script from "./knob.vue?vue&type=script&lang=ts&"
export * from "./knob.vue?vue&type=script&lang=ts&"
import style0 from "./knob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports